// extracted by mini-css-extract-plugin
export default {"popup":"errorPopup_popup__nMBIj","popup__title":"errorPopup_popup__title__RTtPF","popup__img":"errorPopup_popup__img__qYHKt","popup__nextBtn":"errorPopup_popup__nextBtn__pT6t5"};